"use strict";'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var chunkAC6LRJIW_js = require('./chunk-AC6LRJIW.js');
var chunkPBLNC4OF_js = require('./chunk-PBLNC4OF.js');
var react = require('react');
var reactAria = require('react-aria');
var downshift = require('downshift');
var jsxRuntime = require('react/jsx-runtime');
var w = require('styled-components');
var faAngleDown = require('@fortawesome/pro-solid-svg-icons/faAngleDown');
var reactAriaComponents = require('react-aria-components');
var faCircleXmark = require('@fortawesome/pro-regular-svg-icons/faCircleXmark');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var w__default = /*#__PURE__*/_interopDefaultLegacy(w);

function L(){let o=react.useRef(null),[t,e]=react.useState(0);return react.useLayoutEffect(()=>{let r=new ResizeObserver(()=>{o.current&&e(o.current.offsetWidth);});return o.current&&r.observe(o.current),()=>{o.current&&r.unobserve(o.current);}},[]),{ref:o,width:t}}var v=react.createContext(null);function R(o){return o?o.label:""}function bo(o,t,e,r){let n=e.toLowerCase();return o.filter(i=>!t.includes(i)&&r(i.label,n))}var $=({children:o,items:t,onChange:e,error:r,initialSelectedItems:n,disabled:i,itemToString:a=R})=>{let{width:l,ref:p}=L(),[u,g]=react.useState(""),[s,f]=react.useState(n),{contains:h}=reactAria.useFilter({sensitivity:"base"}),x=react.useMemo(()=>bo(t,s!=null?s:[],u,h),[t,s,u,h]),{getSelectedItemProps:T,getDropdownProps:N,removeSelectedItem:z}=downshift.useMultipleSelection({selectedItems:s,onStateChange({selectedItems:b,type:C}){switch(C){case downshift.useMultipleSelection.stateChangeTypes.SelectedItemKeyDownBackspace:case downshift.useMultipleSelection.stateChangeTypes.SelectedItemKeyDownDelete:case downshift.useMultipleSelection.stateChangeTypes.DropdownKeyDownBackspace:case downshift.useMultipleSelection.stateChangeTypes.FunctionRemoveSelectedItem:e==null||e(b!=null?b:[]),f(b);break;}}}),O=downshift.useCombobox({inputValue:u,items:x,defaultHighlightedIndex:0,itemToString:a,selectedItem:null,stateReducer(b,C){let{changes:B,type:P}=C;switch(P){case downshift.useCombobox.stateChangeTypes.InputKeyDownEnter:case downshift.useCombobox.stateChangeTypes.ItemClick:return {...B,isOpen:!0,highlightedIndex:0};default:return B}},onStateChange({type:b,selectedItem:C,inputValue:B}){switch(b){case downshift.useCombobox.stateChangeTypes.InputKeyDownEnter:case downshift.useCombobox.stateChangeTypes.ItemClick:case downshift.useCombobox.stateChangeTypes.InputBlur:if(C){let P=[...s!=null?s:[],C];f(P),e==null||e(P),g("");}break;case downshift.useCombobox.stateChangeTypes.InputChange:g(B!=null?B:"");break;}}});react.useEffect(()=>{n&&n.forEach(b=>{O.selectItem(b);});},[n]);let io=react.useMemo(()=>({...O,formFieldRef:p,menuWidth:l,items:x,error:r,getSelectedItemProps:T,getDropdownProps:N,removeSelectedItem:z,isMulti:!0,disabled:i,selectedItems:s!=null?s:[]}),[O,p,l,x,r,T,N,z,s,i]);return jsxRuntime.jsx(v.Provider,{value:io,children:o})};var K=({children:o,items:t,onChange:e,value:r,error:n,disabled:i,itemToString:a=R})=>{let[l,p]=react.useState(t),{width:u,ref:g}=L(),{contains:s}=reactAria.useFilter({sensitivity:"base"}),f=downshift.useCombobox({items:l,defaultHighlightedIndex:0,itemToString:a,onInputValueChange:({inputValue:x})=>{p(x?t.filter(T=>s(T.label.toLowerCase(),x.toLowerCase())):t);},onSelectedItemChange:({selectedItem:x})=>{e==null||e(x);}});react.useEffect(()=>{p(t);},[t]),react.useEffect(()=>{r&&f.selectItem(r);},[r]);let h=react.useMemo(()=>({...f,formFieldRef:g,menuWidth:u,items:l,error:n,isMulti:!1,disabled:i}),[f,g,u,l,n,i]);return jsxRuntime.jsx(v.Provider,{value:h,children:o})},m=()=>{let o=react.useContext(v);if(o===null)throw new Error("useComboBoxContext must be used within a ComboBoxProvider");return o};var yo=({children:o,onChange:t,value:e,error:r,items:n,disabled:i})=>jsxRuntime.jsx(K,{items:n,onChange:t,value:e,error:r,disabled:i,children:o}),q=({children:o,onChange:t,error:e,items:r,initialSelectedItems:n=[],disabled:i})=>jsxRuntime.jsx($,{items:r,onChange:t,error:e,initialSelectedItems:n,disabled:i,children:o});q.displayName="MultiComboBox";var Io=yo;function d(o){return t=>{o.forEach(e=>{typeof e=="function"?e(t):e&&(e.current=t);});}}var Po=w__default["default"](chunkPBLNC4OF_js.b)`
  color: var(--foreground-secondary);
`,Mo=w__default["default"].button`
  border: none;
  background: transparent;
  padding: 0;
  margin: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
`,S=react.forwardRef((o,t)=>{let{getToggleButtonProps:e,disabled:r}=m(),n=e();return jsxRuntime.jsx(Mo,{...o,...n,disabled:r,ref:d([n.ref,t]),"aria-label":"Show suggestions",type:"button",children:jsxRuntime.jsx(Po,{size:"regular",icon:faAngleDown.faAngleDown})})});S.displayName="ComboBoxTriggerButton";w__default["default"](S)``;var Ro=w__default["default"].div`
  display: flex;
  padding: var(--spacing-small) var(--spacing-regular);
  gap: var(--spacing-regular);
  border-radius: var(--border-radius-small);
  border: 1px solid var(--border-input-default);
  background: var(--background-input-default);
  min-height: 42px;

  ${o=>o.isOpen&&w.css`
      border: 1px solid var(--border-input-active);
      box-shadow: 0 0 0 2px var(--border-input-active-outline);
    `}

  &:hover {
    border: 1px solid var(--border-input-hover);
  }

  &:focus-within {
    border: 1px solid var(--border-input-active);
    box-shadow: 0 0 0 2px var(--border-input-active-outline);
  }

  &:has(input:invalid) {
    --border-input-default: var(--border-input-error);
    --border-input-hover: var(--border-input-error);
    --border-input-active: var(--border-input-error);
    --border-input-active-outline: var(--border-input-error-outline);
  }

  ${o=>o.error&&w.css`
      --border-input-default: var(--border-input-error);
      --border-input-hover: var(--border-input-error);
      --border-input-active: var(--border-input-error);
      --border-input-active-outline: var(--border-input-error-outline);
    `}

  &:has(input:disabled) {
    --border-input-active: var(--border-input-disabled);
    --border-input-default: var(--border-input-disabled);
    --border-input-hover: var(--border-input-disabled);
    --border-input-active-outline: var(--border-input-disabled);
    --background-input-default: var(--color-neutral-50);
  }
`,So=w__default["default"].div`
  display: flex;
  gap: 4px var(--spacing-x-small);
  flex: 1 0 0;
  flex-wrap: wrap;
`,Y=react.forwardRef(({children:o,...t},e)=>{let r=m(),{formFieldRef:n,isOpen:i,error:a,disabled:l}=r;return jsxRuntime.jsxs(Ro,{...t,isOpen:i,error:a,ref:d([n,e]),disabled:l,children:[jsxRuntime.jsx(So,{children:o}),jsxRuntime.jsx(S,{})]})});Y.displayName="ComboboxField";var wo=w__default["default"](Y)``;var Ao=w__default["default"].input`
  outline: none;
  border: none;
  background: transparent;
  flex: 1 1;
  font-size: ${o=>o.$size==="small"?"var(--font-size-small)":"var(--font-size-regular)"};

  ::placeholder {
    font-style: italic;
    color: var(--foreground-input-placeholder);
  }
`,_=react.forwardRef(({size:o="regular",...t},e)=>{let r=m(),{getInputProps:n,isOpen:i}=r,a=r.isMulti?n(r.getDropdownProps({preventKeyAction:i})):n();return jsxRuntime.jsx(Ao,{$size:o,disabled:r.disabled,...t,...a,ref:d([a==null?void 0:a.ref,e])})});_.displayName="ComboBoxInput";var Eo=w__default["default"](_)``;var Do=w__default["default"].ul`
  list-style: none;
  margin: 0;
  padding: var(--spacing-x-small);
  overflow: auto;
  box-sizing: border-box;
`,j=w__default["default"].li`
  text-align: center;
  padding: var(--spacing-small) var(--spacing-regular);
  overflow: hidden;
  color: var(--foreground-tertiary);
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: var(--font-size-regular);
`,Vo=w__default["default"](reactAriaComponents.Popover)`
  border-radius: var(--border-radius-small);
  background: var(--background-level-3);
  box-shadow: var(--elevation-300);
  overflow: auto;
`,eo=react.forwardRef(({children:o,emptyStateMessage:t},e)=>{let{formFieldRef:r,isOpen:n,getMenuProps:i,menuWidth:a,items:l}=m(),p=i({style:{width:a}});reactAria.usePreventScroll({isDisabled:!n});let u=!!t;return jsxRuntime.jsxs(jsxRuntime.Fragment,{children:[!n&&jsxRuntime.jsx("span",{...p,style:{display:"none"}}),jsxRuntime.jsx(Vo,{triggerRef:r,isOpen:n,placement:"bottom start",offset:5,shouldUpdatePosition:!0,shouldFlip:!0,isNonModal:!0,...p,children:jsxRuntime.jsxs(Do,{ref:d([p.ref,e]),children:[l.length===0&&!u&&jsxRuntime.jsx(j,{children:jsxRuntime.jsx("span",{children:"No results found"})}),l.length===0&&u&&jsxRuntime.jsx(j,{children:t}),typeof o=="function"?o(l):o]})})]})});eo.displayName="ComboBoxListBox";var Wo=w__default["default"](eo)``;var qo=w__default["default"].li`
  display: flex;
  padding: var(--spacing-small) var(--spacing-regular);
  align-items: center;
  gap: var(--spacing-small);
  align-self: stretch;
  cursor: pointer;
  border-radius: var(--border-radius-small);
  border: 2px solid transparent;
  font-size: var(--font-size-regular);

  ${o=>o.isHighlighted&&w.css`
      border: 2px solid var(--border-link-focus);
    `}
`,Qo=w__default["default"].span``,ro=react.forwardRef(({children:o,item:t,...e},r)=>{let n=m(),i=n.getItemProps({item:t,index:e.index});return jsxRuntime.jsx(qo,{...e,...i,ref:d([i.ref,r]),isHighlighted:e.index===n.highlightedIndex,children:jsxRuntime.jsx(Qo,{children:o})})});ro.displayName="ComboBoxItem";var Xo=w__default["default"](ro)``;var no=({children:o,...t})=>{let{getLabelProps:e}=m(),r=e();return jsxRuntime.jsx(chunkAC6LRJIW_js.a,{...t,...r,children:o})};no.displayName="ComboBoxLabel";var Jo=w__default["default"](no)``;var Zo=({children:o})=>{let t=m(),{isMulti:e}=t;if(!e)return null;let{selectedItems:r,removeSelectedItem:n}=t;return jsxRuntime.jsx(jsxRuntime.Fragment,{children:r.map(i=>o(i,n))})},_o=Zo;var re=w__default["default"].div`
  padding: 0 var(--spacing-small);
  align-items: center;
  gap: var(--spacing-small);
  border-radius: var(--border-radius-small);
  background: var(--background-boolean-hover);
  max-width: 215px;
  display: inline-flex;
    
    font-size: ${o=>o.$size==="small"?"var(--font-size-small)":"var(--font-size-regular)"};
    }
`,ne=w__default["default"].span`
  color: var(--foreground-primary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`,ie=w__default["default"].button`
  color: var(--foreground-primary);
  background: transparent;
  border: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
`,se=react.forwardRef(({children:o,item:t,removeSelectedItem:e,...r},n)=>jsxRuntime.jsxs(re,{...r,ref:n,children:[jsxRuntime.jsx(ne,{children:o}),jsxRuntime.jsx(ie,{type:"button",onClick:i=>{i.preventDefault(),e(t);},children:jsxRuntime.jsx(chunkPBLNC4OF_js.b,{size:"small",icon:faCircleXmark.faCircleXmark,colorToken:"foreground-secondary"})})]})),me=w__default["default"](se)``;

exports.a = q;
exports.b = Io;
exports.c = wo;
exports.d = Eo;
exports.e = Wo;
exports.f = Xo;
exports.g = Jo;
exports.h = _o;
exports.i = me;
